import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import EmojiRating from '../../components/SliderEmoji/IndexSliderEmoji'
import SignUp from '../../components/SignUp/IndexSignUp'
import swal from 'sweetalert'

// core components
import LandingNavbar from "../../components/Navbars/LandingNavbar.js"
import LandingPageHeader from "../../components/Headers/LandingPageHeader.js"
import DefaultFooter from "../../components/Footers/DefaultFooter.js"

function LandingPage() {
  const [isQuestModal, setIsQuestModal] = useState(false)
  const [isRegisModal, setIsRegisModal] = useState(false)
  const [questScore, setQuestScore] = useState(0)

  const [questItems, setQuestItems] = useState([
    { label: '1. กลัวทำงานผิดพลาด', value: 3 },
    { label: '2. ไปไม่ถึงเป้าหมายที่วางไว้', value: 3 },
    { label: '3. ครอบครัวมีความขัดแย้งกันในเรื่องเงินหรือ เรื่องงานในบ้าน', value: 3 },
    { label: '4. เป็นกังวลกับเรื่องสารพิษ หรือมลภาวะในอากาศ น้ำ เสียง และดิน', value: 3 },
    { label: '5. รู้สึกว่าต้องแข่งขันหรือเปรียบเทียบ', value: 3 },
    { label: '6. เงินไม่พอใช้จ่าย', value: 3 },
    { label: '7. กล้ามเนื้อตึงหรือปวด', value: 3 },
    { label: '8. ปวดหัวจากความตึงเครียด', value: 3 },
    { label: '9. ปวดหลัง', value: 3 },
    { label: '10. ความอยากอาหารเปลี่ยนแปลง', value: 3 },
    { label: '11. ปวดศีรษะข้างเดียว', value: 3 },
    { label: '12. รู้สึกวิตกกังวล', value: 3 },
    { label: '13. รู้สึกคับข้องใจ', value: 3 },
    { label: '14. รู้สึกโกรธหรือหงุดหงิด', value: 3 },
    { label: '15. รู้สึกเศร้า', value: 3 },
    { label: '16. ความจาไม่ดี', value: 3 },
    { label: '17. รู้สึกสับสน', value: 3 },
    { label: '18. ตั้งสมาธิลำบาก', value: 3 },
    { label: '19. รู้สึกเหนื่อยง่าย', value: 3 },
    { label: '20. เป็นหวัดบ่อย ๆ', value: 3 },
  ])

  useEffect(() => {
    document.body.classList.add("landing-page")
    document.body.classList.add("sidebar-collapse")
    document.documentElement.classList.remove("nav-open")
    window.scrollTo(0, 0);
    document.body.scrollTop = 0
    return function cleanup() {
      document.body.classList.remove("landing-page")
      document.body.classList.remove("sidebar-collapse")
    }
  }, [])

  const _onSelect5Change = (idx, value) => {
    console.log(value)
    let sqs = Object.assign(questItems, {})
    sqs[idx].value = value
    setQuestItems(sqs)
  }
  const _onClickQuestModal = () => {
    setIsQuestModal(true)
  }

  const _onClickRegisterModal = () => {
    setIsRegisModal(true)
  }

  const _onSave = () => {
    const item = questItems
    let score = 0
    for (let i = 0; i < item.length; i++) {
      score += item[i].value
    }
    setQuestScore(score)
    setIsQuestModal(false)
    setIsRegisModal(true)
  }

  const _onBack = () => {
    setIsRegisModal(false)
    setIsQuestModal(true)
  }

  const _onSuccess = (result) => {
    if (result) {
      setIsRegisModal(false)
      swal({
        title: "สมัครสมาชิกสำเร็จ!",
        text: "เราจะดำเนินการติดต่อกลับโดยเร็วที่สุด",
        icon: "success",
        button: "ตกลง",
      })
    }
  }

  return (
    <>
      <LandingNavbar />
      <div className="wrapper">
        <LandingPageHeader onClickRegisterModal={_onClickRegisterModal} />
        <div className="section section-about-us" style={{ paddingTop: '10px' }}>
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">MSU Chat</h2>
                <h5 className="description">
                  MSU Chat เป็นแพลตฟอร์มหนึ่งของศูนย์ความเป็นเลิศทางจิตวิทยา ภาควิชาจิตวิทยาการศึกษา และการแนะแนว คณะศึกษาศาสตร์ มหาวิทยาลัยมหาสารคาม เพื่อให้บริการปรึกษาประเด็นสุขภาพจิตและการปรับตัว 
                  อาทิ รับบริการรู้จักและเข้าใจตนเองและผู้อื่น ความเครียดในชีวิตประจำวัน สัมพันธภาพ การปรับตัว สุขภาวะ รวมถึง การแนะแนวการศึกษาและอาชีพ
                </h5>
              </Col>
            </Row>
            <div className="separator separator-primary"></div>
            <div className="section-story-overview">
              <Row>
                <Col md="6">
                  <div
                    className="image-container image-left"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/msu_chat_ios.png") + ")",
                      width: '350px',
                      height: '730px',
                      borderRadius: '40px',
                    }}
                  >
                  </div>
                </Col>
                <Col md="5">
                  <Button color="neutral"><img src={require("assets/img/app_store.png")} /></Button>
                  <Button color="neutral" target="_blank" href="https://play.google.com/store/apps/details?id=org.msu.chat&hl=en_US"><img src={require("assets/img/play_store.png")} /></Button>
                  <div className="section-team text-center">
                    <Container>
                      {/* <h2 className="title">ผู้วิจัย</h2>
                      <div className="team">
                        <Row>
                          <Col>
                            <div className="team-player">
                              <img
                                alt="..."
                                className="rounded-circle img-fluid img-raised"
                                src={require("assets/img/khanitin.jpg")}
                              ></img>
                              <h4 className="title">นายคณิติน จรโคกกรวด</h4>
                            </div>
                          </Col>
                        </Row>
                      </div> */}
                    </Container>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>

        <Modal isOpen={isQuestModal} >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() => setIsQuestModal(false)}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h4 className="title title-up">แบบประเมินความเครียดก่อนรับบริการ</h4>
          </div>
          <ModalBody>

            {questItems.map((item, idx) => {
              return (
                <div key={item.label}>
                  <span style={{ fontWeight: 'bold' }}>{item.label}</span>
                  <div style={{ marginTop: '50px' }}></div>
                  <div style={{ marginBottom: '-110px'}}>
                  <div className="row" style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '-17px', marginLeft: '8px', marginRight: '9px' }}>
                    <span style={{ color: '#4fc0a0' , fontSize: '23px'}}>&#10073;</span>
                    <span style={{ color: '#4fc0a0' , fontSize: '23px'}}>&#10073;</span>
                    <span style={{ color: '#4fc0a0' , fontSize: '23px'}}>&#10073;</span>
                    <span style={{ color: '#4fc0a0' , fontSize: '23px'}}>&#10073;</span>
                    <span style={{ color: '#4fc0a0' , fontSize: '23px'}}>&#10073;</span>
                  </div>
                  <div className="row" style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <span style={{ color: '#4fc0a0' }}>น้อยมาก</span>
                    <span style={{ color: '#FA8072' }}>น้อย</span>
                    <span style={{ color: '#FF6347' }}>ปานกลาง</span>
                    <span style={{ color: '#FF4500' }}>มาก</span>
                    <span style={{ color: '#FF0000' }}>มากที่สุด</span>
                  </div>
                  </div>
                  <EmojiRating
                    variant='smileys'
                    scoreValue={questItems[idx].value}
                    onSlide={(value) => _onSelect5Change(idx, value)}
                  />
                  <hr style={{ width: '100%' }}></hr>
                </div>
              )
            })}
          </ModalBody>
          <div className="modal-footer">
            <Button
              className="btn-round"
              color="info"
              type="button"
              onClick={() => _onSave()}>
              ถัดไป
                  </Button>
            <Button
              className="btn-round"
              color="primary"
              outline
              onClick={() => setIsQuestModal(false)}
            >
              ยกเลิก
            </Button>
          </div>
        </Modal>
        <Modal
          isOpen={isRegisModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() => setIsRegisModal(false)}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">สมัครบริการ</h3>
          </div>
          <ModalBody>
            <SignUp
              score={questScore}
              onSuccess={(result) => _onSuccess(result)}
            />
          </ModalBody>
        </Modal>
        <DefaultFooter />
      </div>
    </>
  );
}

export default LandingPage;
